import styled from 'styled-components';
import { marginStyles } from '../../styles/components.js';

const LogoSvg = styled.svg `
  display: inline-block;
  vertical-align: text-bottom;

  ${props => marginStyles(props.margin)};
`;

export { LogoSvg };
